interface OutlinedFieldProps {
  id: string;
  label: string;
  required?: boolean;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  error?: string;
  inputMode?: 'text' | 'numeric';
}

/** Outlined input with the label sitting on the border (design Screen 3). */
export function OutlinedField({
  id,
  label,
  required,
  value,
  onChange,
  placeholder,
  error,
  inputMode = 'text'
}: Readonly<OutlinedFieldProps>) {
  return (
    <div className="relative mt-3">
      <label
        htmlFor={id}
        className="absolute -top-2.5 left-3 z-10 bg-white px-1 text-sm font-semibold text-[#0F172A]"
      >
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        id={id}
        inputMode={inputMode}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        aria-invalid={!!error}
        className="w-full rounded-lg border border-gray-300 px-4 py-3 text-base text-gray-900 placeholder:text-gray-400 focus:border-[#5CB891] focus:outline-none focus:ring-1 focus:ring-[#5CB891]"
      />
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
}
